import { create } from 'zustand';
import { shallow } from 'zustand/shallow';
import { UserAgent } from '@mirinae/js-utils';

export const useAppVersionStore = create((set, get) => ({
    isAppChecked: false,
    isApp: false,
    versionParam: '',
    appVersion: 0,
    isProEnabledVersion: false,
    isPricePlan3PlusEnabled: false,
    isAdMobAdsEnabled: false,
    displayMustUpgradeApp: null,

    methods: {
        setVersionData: (data) => set({ ...data }),
    },
}));

export const useAppVersionStoreMethods = () =>
    useAppVersionStore((state) => state.methods, shallow);
export const useAppVersionStoreAndMethods = (stateGetter, flags) => [
    useAppVersionStore(stateGetter, flags),
    useAppVersionStore((state) => state.methods, shallow),
];


// Coupon links (#116) show only on the website on a computer. Inside the app they must never show (App Store
// 3.1.1), and on a phone a slow app start can look like the website for a moment (appBase.js, "Late app
// detection"), so phones get none; a phone opens the address printed on the coupon instead.
export const useShowCouponLinks = () => {
    const isApp = useAppVersionStore(state => state.isApp);
    const isAppChecked = useAppVersionStore(state => state.isAppChecked);
    const { os } = UserAgent;
    return isAppChecked && !isApp && !(os.isAndroid || os.isIos);
};
